module.exports = __webpack_public_path__ + "static/media/YM66_1.e5bbd47b.jpg";